module.exports = __webpack_public_path__ + "img/logo53.7c80da15.png";